module.exports = __webpack_public_path__ + "static/media/max-happy.9b6dc084.png";